import { useContext } from "react";
import { GipContext } from "state";
import s from "./filter.module.css";

const Counter = ({ name, value }) => (
  <div className="text-center pt-1 pb-1 pl-4 pr-4 sm:pt-4 sm:pb-4">
    <p className={`${s.value}`} >{value}</p>
    <p className={`${s.name} !text-[10px] sm:text-xs`} >{name}</p>
  </div>
);

export default function Counters({cssClasses}) {
  const { gipsCount, countriesCount, companiesCount } = useContext(GipContext);

  return (
    <div className={`${cssClasses} flex justify-between border-b border-gray-200 sm:border-b-0 items-center bg-gray-50 px-12 py-0`}>
      <Counter name="projects" value={gipsCount} />
      <Counter name="countries" value={countriesCount} />
      <Counter name="companies" value={companiesCount} />
    </div>
  );
}
